/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Product } from './Product';
import {
    ProductFromJSON,
    ProductFromJSONTyped,
    ProductToJSON,
    ProductToJSONTyped,
} from './Product';

/**
 * 
 * @export
 * @interface PriceListProduct
 */
export interface PriceListProduct {
    /**
     * 
     * @type {number}
     * @memberof PriceListProduct
     */
    id: number;
    /**
     * 
     * @type {Product}
     * @memberof PriceListProduct
     */
    product: Product;
    /**
     * 
     * @type {string}
     * @memberof PriceListProduct
     */
    price: string;
}

/**
 * Check if a given object implements the PriceListProduct interface.
 */
export function instanceOfPriceListProduct(value: object): value is PriceListProduct {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('product' in value) || value['product'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    return true;
}

export function PriceListProductFromJSON(json: any): PriceListProduct {
    return PriceListProductFromJSONTyped(json, false);
}

export function PriceListProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceListProduct {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'product': ProductFromJSON(json['product']),
        'price': json['price'],
    };
}

export function PriceListProductToJSON(json: any): PriceListProduct {
    return PriceListProductToJSONTyped(json, false);
}

export function PriceListProductToJSONTyped(value?: PriceListProduct | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'product': ProductToJSON(value['product']),
        'price': value['price'],
    };
}

